import { type QueryClient, useQueryClient } from "@tanstack/react-query";

import { USER_INFO_QUERY_KEY } from "Auth/Api/Queries/useUserInfoQuery";
import { JWT_KEY } from "Auth/Models/AuthConstants";

export function useSignOut() {
	const queryClient = useQueryClient();
	return () => {
		processSignOut(queryClient);
	};
}

export function processSignOut(queryClient: QueryClient) {
	localStorage.removeItem(JWT_KEY);
	queryClient.invalidateQueries({ queryKey: [USER_INFO_QUERY_KEY] });
}
